import { render, staticRenderFns } from "./GameUIComponent.vue?vue&type=template&id=16fa83ba&scoped=true&"
import script from "./GameUIComponent.vue?vue&type=script&lang=js&"
export * from "./GameUIComponent.vue?vue&type=script&lang=js&"
import style0 from "./GameUIComponent.vue?vue&type=style&index=0&id=16fa83ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa83ba",
  null
  
)

export default component.exports